<template>
  <div v-if="inputType !== 'hidden'" :class="`form-element form-${type}-element`">
    <component
      v-bind:is="options.keyboard === 'textarea' ? 'v-textarea' : 'v-text-field'"
      v-model="internalValue"
      :rows="options.keyboard === 'textarea' ? 2 : null"
      :auto-grow="options.keyboard === 'textarea' ? true : null"
      :required="options.required"
      :type="inputType"
      :label="options.title"
      :placeholder="options.placeholder"
      :rules="rules"
      :readonly="options.readonly"
      :tabindex="tabindex"
      hide-details
    >
      <template v-slot:label>
        <FormLabel
          input-label
          :required="options.required"
          :title="options.title"
          :filled="!!internalValue"
          :field-type="type"
        />
      </template>
    </component>
  </div>
</template>

<script>
import FormLabel from '../FormLabel';
import { VTextField, VTextarea } from 'vuetify/lib';

export default {
  components: {
    FormLabel,
    VTextField,
    VTextarea
  },
  props: {
    tabindex: { type: [String, Number], default: null },
    value: { type: [String, Number], default: null },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  computed: {
    internalValue: {
      get () {
        return (this.value === null || this.value === undefined) ? this.options.default : this.value;
      },
      set (v) {
        this.$emit('input', v);
      }
    },
    rules () {
      if (this.options.keyboard === 'number') {
        return [
          value => !isNaN(value)
        ];
      }

      return [];
    },
    inputType () {
      if (this.options.keyboard) {
        if (this.options.keyboard === 'phone') {
          return 'tel';
        }

        return this.options.keyboard;
      }

      return 'text';
    }
  }
};
</script>
